import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { HttpService } from '../shared/services/http.service';
import { ControllerService } from '../shared/services/controller.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss'],
    standalone: false
})
export class ReportComponent implements OnInit {

  userCount = 0
  completedCount = 0

  cdn = environment.audioBaseDir

  super = false

  page = 0
  size = 10

  reportData: any = [];
  dataSource: any;

  academicYears = []
  academicYearFilter = null
  codes = []
  code = null

  clientId = -1
  clientName = ''
  clientNameFull = ''
  tagId: string | null = null
  kind = null

  userFilter = ''

  filterDebounce: any

  displayedColumns = [];
  @ViewChild(MatSort, { static: true }) sort: MatSort = new MatSort();

  @ViewChild('hiddenDownloadReport', { static: false }) hiddenDownloadReport
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;


  loaded = false




  totals : any = {}

  columnNames = [
    {
      id: "client_name",
      value: "Client Name"
    },
    { value:'Client type',
      id:'kind'
    },
    {
      id: "code",
      value: "Code",
    },
    {
      id: "description",
      value: "Code Description",
    },
    {
      id: "email",
      value: "Email",
    },
    {
      id: 'registered_date',
      value: 'Registered'
    },
    {
      id: 'completed_on',
      value: 'Completed On'
    },
    {
      id: "time_spent_minutes",
      value: "Time Spent (minutes)"
    },
    {
      id: "complete",
      value: "Completed",
    },


  ];

  constructor(private httpService: HttpService, public controller: ControllerService, private route: ActivatedRoute, private router: Router, private cdr: ChangeDetectorRef) {

  }

  async onPaginateChange(event: PageEvent) {
    this.page = event.pageIndex;
    this.size = event.pageSize;


    await this.fetchReport( this.clientId, this.page, this.size, this.kind, this.userFilter );

    this.cdr.detectChanges(); // Force change detection

  }


  async fetchAcademicYears(){

    const res:any = await this.httpService.postAsync("report/academicYears", {})

    this.academicYears = res.academicYears
  }

  async selectAcademicYear( event ){

    let year = event.target.value || null

    this.academicYearFilter = this.academicYears.find( yearObject => yearObject.formatted_year == year )

    await this.fetchReport( this.clientId, this.page, this.size, this.kind ,this.userFilter );

  }

  async downloadReport( ){

    let csvContent = 'data:text/csv;charset=utf-8,'

    csvContent += 'sep=;\r\n'

    let columnNames = [...this.columnNames]

    columnNames.push({id:'training_start_date',value:'Training start date'})

    if( this.clientId > 0 && !this.clientName.endsWith('Parent') ){
      columnNames.splice(0,2)
    }

    columnNames.forEach( ({value}) => {
      csvContent += value + ';'
    })

    csvContent += '\r\n'

    const idsInArray = columnNames.map( ({id}) => id )

    // fetch all.
    const response:any = await this.httpService.postAsync("report/hrReport", {clientId: this.clientId, page:0, size:0, filter: this.userFilter, kind: this.kind, academicYear : this.academicYearFilter, code: this.code, tagId: this.tagId})

    if( !response.success ){
      alert("Sorry, an error occured loading the report")
      return
    }

    const {data} = response

    data.forEach( (rowObject) => {
      const rowArray = idsInArray.reduce( (acc,id) => {
        rowObject.time_spent_minutes = rowObject.time_spent ? Math.round((rowObject.time_spent) / 60) : '-',

        acc.push(rowObject[id])
        return acc
      }, [])

      let row = rowArray.join(';')
      csvContent += row + '\r\n'
    })


    const today = new Date(Date.now()).toLocaleString().split(',')[0].replace(/\//g,'-')

    // remove data:text/csv;charset=utf-8, from csvContent
    csvContent = csvContent.replace('data:text/csv;charset=utf-8,', '')

    const blob = new Blob([csvContent]);

    // Create a temporary URL for the blob
    const url = URL.createObjectURL(blob);

    // Create a hidden link and trigger download
    const link = document.createElement('a');
    link.href = url;
    link.download = `${this.clientName}-completion-${today}.csv`;
    document.body.appendChild(link); // Required for Firefox
    link.click();

    // Clean up the blob URL
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

  }

  openActionReport( ){
    this.router.navigate([`client/${this.clientName}/actions`])
  }

  filter( event ){

    if( this.filterDebounce ){
      window.clearTimeout( this.filterDebounce )
    }

    this.filterDebounce = window.setTimeout( async () => {

      this.userFilter = event.target.value.trim()

      this.page = 0

      await this.fetchReport( this.clientId, this.page, this.size, this.kind ,this.userFilter );

    }, 250 )

  }

  getSummary(data){

    const {complete, countUsers} = data


   this.totals = {
    code: '-',
    description: '-',
    name: '-',
    email: '-',
    ts: '-',
    complete: complete > 0  ? Math.round((complete / countUsers) * 100) + '%' : 0,
   }

   this.userCount = countUsers
   this.completedCount = complete

  }

  async ngOnInit() {



    this.controller.shiftContainerToTop()

    this.super = this.controller.isSuper()

    this.controller.setPreviewing(false)

    await this.fetchAcademicYears()

    this.tagId = this.route.snapshot.queryParamMap.get('tagId');

    this.route.url.subscribe( async (url: Params) => {
      this.clientName = url[1].path
      this.clientId = this.controller.getClientId(url[1].path)
      if( this.clientName == '_ALL_' || this.tagId){
        this.clientId = 0;
      }

      this.clientNameFull = this.controller.getClientName(this.clientId)

      this.displayedColumns = this.columnNames.map(x => x.id);
      if( this.clientId > 0 ){
        this.displayedColumns.splice(0,2)
      }
      this.dataSource = new MatTableDataSource(this.reportData);
      this.dataSource.sort = this.sort;


      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'completed_on':
            var parts = item[property] ? item[property].split("-") : '-';
            const newDate = item[property] ? new Date(parts[2], parts[1] - 1, parts[0]) : 0;
            return newDate;

          case 'registered_date': {
            var parts = item[property].split("-");
            const newDate = new Date(parts[2], parts[1] - 1, parts[0]);
            return newDate;
          }
          default: {
            return item[property];
          }
        }
      };

      await this.fetchReport( this.clientId, this.page, this.size )

      await this.fetchCodes()

    })
  }

  async sortData($event){
    await this.fetchReport( this.clientId, this.page, this.size, this.kind, this.userFilter )
  }

  async selectTypeFilter( event ){
    const k = event.target.value || null

    this.kind = k

    await this.fetchReport( this.clientId, this.page, this.size, this.kind, this.userFilter )
  }

  async fetchCodes( ){

    const resp :any = await this.httpService.postAsync("report/allCodesForClient", {clientId: this.clientId})
    this.codes = resp.codes
  }

  async selectCode( event ){

    this.code = event.target.value || null



    await this.fetchReport( this.clientId, this.page, this.size, this.kind, this.userFilter )
  }

  openWindow( url ){
    window.open(this.cdn + '/' + url, '_blank')
  }


  loading = false
  skeletonRows: number[][] = [];

  generateSkeletonRows() {
    this.skeletonRows = Array(10).fill(0).map(() => {
      // Random number of bars between 5 and 8 to ensure density
      const barCount = Math.floor(Math.random() * (8 - 5 + 1)) + 5;
      const bars = [];
      for (let i = 0; i < barCount; i++) {
        // Random flex weight between 1 and 10 to give variety in width
        bars.push(Math.floor(Math.random() * 10) + 1);
      }
      return bars;
    });
  }

  generateSkeletonTable(){
    this.generateSkeletonRows()
  }


  async fetchReport( clientId, page, size, kind = null, filter = null, retry = 0){

    this.loading = true
    this.generateSkeletonRows();
    const sort = {
      active: this.sort.active,
      direction: this.sort.direction
    }

    let response: any
    try{
      // Wait for both the API call and at least 1 second
      const [apiResponse] = await Promise.all([
        this.httpService.postAsync("report/hrReport", {clientId, page, size, filter, kind, academicYear : this.academicYearFilter, code: this.code, sort, tagId: this.tagId, retry}),
        new Promise(resolve => setTimeout(resolve, 250))
      ]);

      response = apiResponse;

      if( response.success ){
        this.reportData = response.data

        this.getSummary(response)
      }else{
        this.reportData = []
        // try again
        if( retry < 3 ){
          console.log("Loading report failed, retrying.")
          await new Promise(resolve => setTimeout(resolve, (retry+1) * 500));
          await this.fetchReport( clientId, page, size, kind, filter, retry + 1 )
        }else{
          alert("An error occurred, please refresh the page to try again.")
        }
      }
    }catch(e){
      this.controller.redirectToSignIn()
    } finally {
      this.loading = false
    }


    this.paginator.length = this.userCount;
    this.paginator.pageIndex = page;

    const data = this.reportData.map( (it) => {
      return {
      ...it,
      time_spent_minutes: it.time_spent ? Math.round((it.time_spent) / 60) : '-',
     }})


     this.dataSource.data = data

     this.loaded = true

  }

}
